<table class="table table-layout"> 
    <thead>
        <tr>
            <th [colSpan]="2">
                Characteristics
            </th>
        </tr>
    </thead>
    <tr>
        <td>Weighted Average Maturity</td>
        <td>{{weightedAverageMaturity}}</td>
    </tr>
    <tr>
        <td>Weighted Average Life</td>
        <td>{{weightedAverageLife}}</td>
    </tr>
</table>